import {
  Button,
  Group,
  LoadingOverlay,
  Modal,
  Stack,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { IconBook2 } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";
import TemplateItem from "./TemplateItem";
import BackButton from "../../../../components/View/BackButton";
import {
  workflow1,
  workflow2,
  workflow3,
  workflow4,
  workflow5,
} from "./workflowProfileTemplates";
import DontShowAgain from "../../../../components/View/DontShowAgain";
import { useSessionStore } from "../../../../stores/UserStore";
import { getWorkflows } from "../../../../api/WorkflowAPI";

const WorkflowTemplates = ({ inWorkflow, onCreated }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [templateItems, setTemplateItems] = useState([]);

  const isReseller = useMemo(() => {
    return reseller.name !== "Magileads";
  }, [reseller]);

  const handleOpen = () => {
    setOpened(true);
    if (isReseller) {
      setLoading(true);
    } else {
      setTemplateItems([workflow1, workflow2, workflow3, workflow4, workflow5]);
    }
  };
  const handleClose = () => {
    setOpened(false);
  };

  useEffect(() => {
    if (loading) {
      getWorkflows(true)
        .then((r) => {
          if (r.data.workflows.length > 0) {
            setTemplateItems(r.data.workflows);
          } else {
            setTemplateItems([
              workflow1,
              workflow2,
              workflow3,
              workflow4,
              workflow5,
            ]);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [loading]);

  return (
    <>
      {inWorkflow ? (
        <Group id="workflow-library" onClick={handleOpen} display={"none"} />
      ) : (
        <Button
          variant="light"
          ml={"auto"}
          onClick={handleOpen}
          radius={"md"}
          leftSection={<IconBook2 size={24} />}
          size="md"
        >
          {lang.workflows.templates.label}
        </Button>
      )}

      <Modal
        opened={opened}
        onClose={handleClose}
        title={<Title order={5}>{lang.workflows.templates.title}</Title>}
        size={"90%"}
      >
        <Group
          mih={"40vh"}
          w={"100%"}
          wrap="nowrap"
          flex={"1 1 auto"}
          justify="space-between"
          px={"md"}
        >
          <LoadingOverlay visible={loading} />
          {templateItems.length === 0 && !loading && (
            <Text size="xl" ta={"center"} c={"dimmed"} w={"100%"}>
              {lang.global.no_element_found}
            </Text>
          )}
          {templateItems.map((item, index) => (
            <TemplateItem
              key={item.id}
              index={index}
              item={item}
              handleClose={handleClose}
              onCreated={onCreated}
              isReseller={isReseller}
            />
          ))}
        </Group>

        {/* <Title order={5} mt={16} mb={16}>
          {lang.workflows.templates.title2}
        </Title>

        <Stack flex={1} h={400}>
          <WorkflowsListing
            closeModal={handleClose}
            wrapperProps={{
              mx: 0,
              w: "100%",
              style: {
                borderBottom: "1px solid #00000016",
              },
            }}
          />
        </Stack> */}

        <Group justify="end" mt={"lg"}>
          <DontShowAgain type="library_auto_show" />
          <BackButton
            onClick={handleClose}
            label={inWorkflow ? lang.workflows.templates.create : undefined}
            size="md"
            variant="light"
          />
        </Group>
      </Modal>
    </>
  );
};

export default WorkflowTemplates;
